<template>
  <div class="c-summary-box">
    <loading-spinner v-if="isLoading"></loading-spinner>
    <ol class="c-summary-box__questions">
      <li class="c-summary-box__question" v-for="(question, index) in summary" v-bind:key="question.id" v-if="question.answerLabel">
        <h3 class="c-summary-box__question-text">{{ question.label }}</h3>
        <h4 class="c-summary-box__answer-text">{{ question.answerLabel }}</h4>
      </li>
    </ol>
    <div class="c-summary-box__actions">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "Components/consumer/_vue-shared/LoadingSpinner.vue";

export default {
  components: {
    LoadingSpinner
  },
  props: {
    isLoading: {
      required: false,
      type: Boolean,
    },
    summary: {
      required: true,
      type: Array,
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/report-a-problem/_vue/SummaryBox.vue